const ValidateDate = (input) => {
	const expression = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
	const isMatch = expression.test(input);
	return isMatch;
};

export default ValidateDate;
